/* @flow */

import * as React from 'react';

export default function useMounted() {
  const [isMounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  return isMounted;
}
